
import '../assets/css/contact.css'
import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
function Contactpage() {
    
    const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    emailjs
      .sendForm(
        "service_hg6uhbi",      // replace
        "template_cw9ucp8",     // replace
        formRef.current,
        "rNpOgqS565UnFV3Ya"       // replace
      )
      .then(
        () => {
          setLoading(false);
          setStatus("Message sent successfully ✔");
          formRef.current.reset();
        },
        () => {
          setLoading(false);
          setStatus("Failed to send message ❌ Try again");
        }
      );
  };

  return (
    <>
      <div className="contacthead">
        <div>
               <h2>
            Let’s create something great together
        </h2>
        <p>
            Interested in working with me or learning more about what I do? Send me a message—I'm happy to help with project inquiries, collaborations, or any questions you may have.
        </p>
        </div>
      </div>

    {/* //   contact us form for client and user  */}
       <div className="con-form">
        <form ref={formRef} onSubmit={sendEmail} >
            <div className="con-input">
                <input type="text" name='form_name' placeholder='Enter Name' />
                <input type="email" name='form_email' placeholder='Enter Email Address' />
                <input type="number" name='form_no' placeholder='Enter Contact Number' />
                <input type="text" name='form_sub' placeholder='Enter Subject' />

            </div>
            <div className="con-text">
                <textarea name="msg" id="" placeholder='Enter Msg Here'>
                    
                </textarea>
            </div>
            <button>
                 {loading ? "Sending..." : "Send Message"}
            </button>
             {status && <p className="status-msg">{status}</p>}

            <p>
                I usually respond within 24 hours
            </p>
        </form>

        <div className="con-info">
            <div className="con-info-list">
                <h4>Contact Me</h4>
                <p>
                    Mobile Number : +91 7297 83 4350
                </p>
                <p>
                    Email : dilipsuthar9829@gmail.com
                </p>
            </div>
             <div className="con-info-list">
                <h4>Social Media</h4>
                 <div className="social-icon">
                    <span>
                        <a href="https://github.com/kumardsuthar" target="_blank"> <i class="fa-brands fa-github"></i></a>
                    </span>
                    <span>
                        <a href="https://www.linkedin.com/in/dilip-kumar-suthar-133791258/" target="_blank"><i class="fa-brands fa-linkedin-in"></i></a>
                    </span>
                    <span>
                        <a href="https://www.instagram.com/d_sthr02/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
                    </span>
                    <span>
                        <a href="https://wa.me/917297834350 " target="_blank">
                        <i class="fa-brands fa-whatsapp"></i>
                        </a>
                    </span>
                  
                 </div>
            </div>
        </div>
       </div>

    </>
  )
}

export default Contactpage
